export default __webpack_public_path__ + "static/media/img_page_error.8cfd2bb1.png";